import React from 'react';
import OptionButton from '../EncounterColumn/OptionButton'
import magPlus from '../../pics/icons/magPlus.PNG'
import magMinus from '../../pics/icons/magMinus.PNG'
import EditStat from './EditStat';
import EditStatTextArea from './EditStatTextArea';
import EditStatSelectDropdown from './EditStatSelectDropdown'
import { exportHomebrewActions } from '../../constants';

const EditLairActions = ({content = [], label, options = exportHomebrewActions, category, handleChange = undefined, nested = -1}) => {

    const handleOptionSelect = (option, actionIndex, contentPath, selectedOptionIndex) => {
        const newName = option
        let desc = options[selectedOptionIndex]?.entries.join("\n\n")
        if(desc.includes('<$')) {
            desc = desc.replaceAll('<$short_name$>', 'this creature')
            desc = desc.replaceAll('<$title_short_name$>', 'This creature')
            desc = desc.replaceAll('DC <$dc__dex$>', '{@dc #DEX}')
            desc = desc.replaceAll('DC <$dc__str$>', '{@dc #STR}')
            desc = desc.replaceAll('DC <$dc__con$>', '{@dc #CON}')
            desc = desc.replaceAll('DC <$dc__wis$>', '{@dc #WIS}')
            desc = desc.replaceAll('DC <$dc__int$>', '{@dc #INT}')
            desc = desc.replaceAll('DC <$dc__cha$>', '{@dc #CHA}')
            desc = desc.replaceAll('<$damage_mod__str$>', '+STR')
            desc = desc.replaceAll('<$to_hit__str$>', 'To Hit #')
            desc = desc.replaceAll(/<\$damage_avg__\d\+str\$>/g, '')
        }
        
        const newDesc = desc

        // handleLairChange = (newValue, action, path)
        handleChange(newName, 'name', contentPath)
        handleChange(newDesc, 'desc', contentPath)
    }


    return (
        <div className='editBlock'>
            {nested === -1 && <i className='editBlockTitle'>{label}</i>}
            {content?.map((contentItem, index) => {
                if(typeof contentItem === 'string') {
                    return (
                        <div className='actionListItem' style={{display: 'flex'}} key={contentItem.substring(0, 20)}>
                            <EditStatTextArea value={contentItem} contentPath={category+"."+index} handleChange={handleChange}/>
                        </div>
                    );
                }

                if(typeof contentItem === 'object') {
                    if(contentItem.type === 'list') {
                        return (
                            <ul>
                                <EditLairActions label={'1 label'} content={contentItem.items} category={category+"."+index+'.items'} handleChange={handleChange} nested={nested+1}/>
                            </ul>
                        )
                    } else if(contentItem.type === "table") {
                        return (
                            <>
                                <b>!!Tables are currently uneditable (Let me know in discord if you need this feature)!! </b>
                                <br/>
                                <table className='spellTable'>
                                    <tr>
                                        {contentItem.colLabels.map((label) => {
                                            return <th>{label}</th>
                                        })}
                                    </tr>
                                    {contentItem.rows.map((row) => {
                                        return <tr>
                                            {row.map((rowData, index) => {
                                                if(typeof rowData === 'object') {
                                                    if(rowData.roll?.exact)
                                                        return <td className='spellTableDice'>{rowData.roll.exact}</td>
                                                    else 
                                                        return <td className='spellTableDice'>{rowData.roll.min} - {rowData.roll.max}</td>
                                                } else {
                                                    return <td className={index ? "" : "spellTableDice"}>{rowData}</td>
                                                }
                                            })}
                                        </tr>
                                    })}
                                </table>
                            </>
                        )
                    }

                    //type: "item" will always only have a name and entry - or entries of size 1
                    return (
                        <div className='actionListItem' key={contentItem?.name}>
                            <li>
                                {contentItem.entry && (
                                    <>
                                        <div style={{display: 'flex', position: 'relative'}}>
                                            <EditStat label={"editContentItemName"} value={contentItem.name} cKey={'name'} category={category+"."+index+'.name'} handleChange={handleChange} showLabel={false} />
                                            <EditStatSelectDropdown current={contentItem.name} dropdownOptions={options.map(o => o.name)} setParentInputs={handleOptionSelect} contentPath={category+"."+index+'.entry'} actionIndex={index}/>
                                            <OptionButton src={magMinus} message={`Remove: ${contentItem?.name}`} onClickFunction={(e) => handleChange(e, 'remove', category+"."+index+'.entry')} wrapperClassName='actionTrash'/>
                                        </div>
                                        4<EditStatTextArea value={contentItem.entry} contentPath={category+'.'+index+'.entry'} handleChange={handleChange}/>
                                    </>
                                )}

                                {contentItem.entries && (
                                    <>
                                        <div style={{display: 'flex', position: 'relative'}}>
                                            <EditStat label={"editContentItemName"} value={contentItem.name} cKey={'name'} category={category+"."+index+'.name'} handleChange={handleChange} showLabel={false} />
                                            <EditStatSelectDropdown current={contentItem.name} dropdownOptions={options.map(o => o.name)} setParentInputs={handleOptionSelect} contentPath={category+"."+index+'.entries'} actionIndex={index}/>
                                            <OptionButton src={magMinus} message={`Remove: ${contentItem?.name}`} onClickFunction={(e) => handleChange(e, 'remove', category+"."+index+'.entries')} wrapperClassName='actionTrash'/>
                                        </div>

                                        <EditLairActions label={'2 list'} content={contentItem.entries} category={category+'.'+index+'.entries'} handleChange={handleChange} nested={nested+1}/>
                                    </>
                                )}
                            </li>
                        </div>
                    )
                }

                return null;
                
            })}

            {nested === -1 &&
                <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                    <OptionButton src={magPlus} message={`Add ${label.slice(0, -1)}`} onClickFunction={(e) => handleChange(e, 'add', category)}/>
                </div>
            }
            
        </div>
    )
}

export default EditLairActions;